"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Map = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/*
 * Map.tsx
 * Author: lnappenfeld
 * Date: 05.10.2022
 *
 * Copyright: DMT GmbH & Co. KG
 */
const react_1 = require("react");
const SimpleOLMap_1 = require("./SimpleOLMap");
const Map = (props) => {
    const projectId = props.projectId;
    const [location, setLocation] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (projectId) {
            props.keycloakfetch.get('/SCC_Measuringpoints?for_map=true&project_id=' + projectId).then(result => {
                if (result)
                    setLocation(result);
            });
        }
    }, [projectId]);
    console.log('map');
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'w-full h-full' }, { children: (0, jsx_runtime_1.jsx)(SimpleOLMap_1.SimpleOLMap, { location: location }) })));
};
exports.Map = Map;
